import React, { Component } from "react";
import MaterialBoxGatedDownloadModal from "./material-box-gated-download/MaterialBoxGatedDownloadModal";
import MaterialBoxGatedEmailModal from "./material-box-gated-email/MaterialBoxGatedEmailModal";
import ButtonAction from "components/utility/button/ButtonAction";

class MaterialBoxButton extends Component {
	constructor(props) {
		super(props);
		this.state = { isOpen: false };
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}
	openModal = () => {
		this.setState({ isOpen: true });
	};
	closeModal = () => {
		this.setState({ isOpen: false });
	};
	render() {
		const { data = {} } = this.props;
		const { downloadUrl } = data;
		const { buttonType, buttonFill, buttonLabel, dataAction, dataCategory, dataLabel } =
			data.button;
		return (
			<div>
				{buttonType === "download" ? (
					<ButtonAction
						className=""
						url={downloadUrl}
						downloadURL={true}
						type={buttonFill}
						width="auto"
						label={buttonLabel}
						isButton="false"
						buttonType="submit"
						onClick={this.openModal}
						disabled={false}
						isTarget={"true"}
						dataALbl={dataLabel}
						dataACat={dataCategory}
						dataAAct={dataAction}
					/>
				) : buttonType === "form-download" ? (
					<div>
						<ButtonAction
							className=""
							type={buttonFill}
							width="auto"
							label={buttonLabel}
							isButton="true"
							buttonType="submit"
							onClick={this.openModal}
							disabled={false}
							dataALbl={dataLabel}
							dataACat={dataCategory}
							dataAAct={dataAction}
						/>

						<MaterialBoxGatedDownloadModal
							data={data}
							isOpen={this.state.isOpen}
							closeModal={this.closeModal}
						/>
					</div>
				) : buttonType === "form-email" ? (
					<div>
						<ButtonAction
							className=""
							type={buttonFill}
							width="auto"
							label={buttonLabel}
							isButton="true"
							buttonType="submit"
							onClick={this.openModal}
							disabled={false}
							dataALbl={dataLabel}
							dataACat={dataCategory}
							dataAAct={dataAction}
						/>
						<MaterialBoxGatedEmailModal
							data={data}
							isOpen={this.state.isOpen}
							closeModal={this.closeModal}
						/>
					</div>
				) : (
					""
				)}
			</div>
		);
	}
}
export default MaterialBoxButton;
